/**
 * React and friends for the page component
 */
import React from 'react';
import './index.css';
/**
 * Render the application
 */
import { createRoot } from 'react-dom/client';

import './services/firebase.service';

/**
 * Set up error and performance analytics
 */
import './analytics/segment';
import './analytics/facebook-pixel';
import './analytics/sentry';

/**
 * Application Component
 */
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
